import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { StoreProvider } from "./context/StoreContext";
import { FilterProvider } from "./context/FilterContext";
import { AuthProvider } from "./context/AuthContext";
import IntroAnimation from "./components/IntroAnimation";
import Navbar from "./components/Navbar";
import CartDrawer from "./components/CartDrawer";
import FilterSidebar from "./components/FilterSidebar";
import StickyWhatsApp from "./components/StickyWhatsApp";
import ProtectedRoute from "./components/ProtectedRoute";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import ProductDetail from "./pages/ProductDetail";
import CheckoutPage from "./pages/CheckoutPage";
import OrderConfirmation from "./pages/OrderConfirmation";
import WishlistPage from "./pages/WishlistPage";
import AdminPage from "./pages/AdminPage";
import CareGuidePage from "./pages/CareGuidePage";
import AuthPage from "./pages/AuthPage";
import AuthCallback from "./pages/AuthCallback";
import MyOrdersPage from "./pages/MyOrdersPage";
import PolicyPage from "./pages/PolicyPage";
import SearchPage from "./pages/SearchPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function AppShell() {
  const location = useLocation();
  const [showIntro, setShowIntro] = useState(() => {
    if (typeof window === "undefined") return false;
    // Only show on the home route, and only if not already seen this session
    if (window.location.pathname !== "/") return false;
    return sessionStorage.getItem("hb_intro_seen") !== "1";
  });

  const handleIntroDone = () => {
    sessionStorage.setItem("hb_intro_seen", "1");
    setShowIntro(false);
  };

  // If Emergent auth returned with session_id in URL fragment, render the callback handler first.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
      {showIntro && <IntroAnimation onDone={handleIntroDone} />}
      <ScrollToTop />
      <Navbar />
      <FilterSidebar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/order-confirmation/:orderNumber" element={<OrderConfirmation />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/jewelry-care" element={<CareGuidePage />} />
        <Route path="/returns" element={<PolicyPage />} />
        <Route path="/privacy" element={<PolicyPage />} />
        <Route path="/shipping" element={<PolicyPage />} />
        <Route path="/terms" element={<PolicyPage />} />
        <Route path="/login" element={<AuthPage mode="login" />} />
        <Route path="/signup" element={<AuthPage mode="signup" />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/my-orders" element={<ProtectedRoute><MyOrdersPage /></ProtectedRoute>} />
      </Routes>
      <CartDrawer />
      <StickyWhatsApp />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#141414",
            color: "#F5F5F5",
            border: "1px solid #F5D565",
            fontFamily: "DM Sans, sans-serif",
            fontSize: "13px",
            letterSpacing: "0.05em",
          },
        }}
      />
    </>
  );
}

function App() {
  return (
    <StoreProvider>
      <FilterProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppShell />
          </AuthProvider>
        </BrowserRouter>
      </FilterProvider>
    </StoreProvider>
  );
}

export default App;
